export default "__VITE_ASSET__a8f03471__"